module.exports = {"component":"global-header","status":"prototype","display-name":"Global Header","SLDS-component-path":"/components/global-header#flavor-base","dependencies":[{"component":"button"},{"component":"dropdown"},{"component":"profile"},{"component":"search"}],"url-slug":"global-header"}


//////////////////
// WEBPACK FOOTER
// ./components/global-header/docs.json
// module id = 213
// module chunks = 0